import Component from '../core/Component'
import Scroll from '../services/Scroll'

export default class DoubleReservation extends Component {
    constructor(element) {
        super(element)

        this.state = {
            form: null,
            formStart: null
        }
    }


    prepare() {
        this.state.form = document.querySelector('#snippet--stayForm')
        Scroll.on('scroll', this.handleScroll)
    }

    destroy() {
        Scroll.off('scroll', this.handleScroll)
    }

    handleScroll = ({ limit, offset }) => {
        if(this.state.formStart === null) {
            let {top, height} = this.state.form.getBoundingClientRect()
            this.state.formStart = top - height
        }

        if(offset.y > this.state.formStart) {
            this.element.style.opacity = "0"
        } else {
            this.element.style.opacity = "1"
        }
    }
}
